module.exports = __webpack_public_path__ + "assets/img/3d0aa4d7c9351dc939b38636bedd1643.svg";